import { getVariable, setVariable, LOCAL_STORAGE_KEYS } from '@/utils/storage.js'
import { SETTINGS_SET_LAST_SELECTED_BRAND_ID, SETTINGS_SET_PREVIEW_VIEWPORT } from './mutation.types.js'
import { SETTINGS_READ_LAST_SELECTED_BRAND, SETTINGS_UPDATE_LAST_SELECTED_BRAND } from './action.types.js'

const state = {
  lastSelectedBrandID: null,
  previewViewportMode: null,
}
const getters = {
  currentBrand: (state, getters) => {
    return getters.brands.find(brand => brand.id === state.lastSelectedBrandID)
  },
  previewViewportMode: state => state.previewViewportMode,
}

const actions = {
  [SETTINGS_READ_LAST_SELECTED_BRAND]({ getters, dispatch }) {
    const brandId = getVariable(getters.user.id, LOCAL_STORAGE_KEYS.LAST_SELECTED_BRAND_ID)

    const allBrands = getters.brands
    let brand = allBrands.find(x => x.id === brandId)
    if (!brand) {
      brand = getters.brands[0]
    }
    return dispatch(SETTINGS_UPDATE_LAST_SELECTED_BRAND, brand)
  },

  [SETTINGS_UPDATE_LAST_SELECTED_BRAND]({ commit, getters }, brand) {
    // Save it with a generic key
    setVariable(getters.user.id, LOCAL_STORAGE_KEYS.LAST_SELECTED_BRAND_ID, brand?.id)
    commit(SETTINGS_SET_LAST_SELECTED_BRAND_ID, brand?.id)
  },
}

const mutations = {
  [SETTINGS_SET_LAST_SELECTED_BRAND_ID](state, id) {
    state.lastSelectedBrandID = id
  },
  [SETTINGS_SET_PREVIEW_VIEWPORT](state, value) {
    state.previewViewportMode = value
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
  name: 'appSettings',
}
